__turbopack_context__.v({
  "calculator_card": "styles-module-scss-module__fDUT9q__calculator_card",
  "calculator_content": "styles-module-scss-module__fDUT9q__calculator_content",
  "calculator_header": "styles-module-scss-module__fDUT9q__calculator_header",
  "calculators_grid": "styles-module-scss-module__fDUT9q__calculators_grid",
  "container": "styles-module-scss-module__fDUT9q__container",
});
